function initQuickAdd(context) {
  const container = context || document;

  container.querySelectorAll('.quick-add-trigger').forEach(button => {
    if (button.dataset.bound) return;
    button.dataset.bound = true;

    button.addEventListener('click', function (event) {
      event.preventDefault();
      const parent = button.closest('.product-grid-item');
      const sizes = parent.querySelector('.product-sizes');

      sizes.classList.toggle('expanded');
      parent.classList.toggle('expanding');
      sizes.querySelectorAll('.quick-add-size').forEach(el => el.classList.remove('dim'));
      
      // Collapse Quick Add text
      button.classList.toggle('collapsed');
    });
  });

  container.querySelectorAll('.quick-add-size').forEach(sizeBtn => {
    if (sizeBtn.dataset.bound) return;
    sizeBtn.dataset.bound = true;

    sizeBtn.addEventListener('mouseenter', function () {
      const container = this.closest('.product-grid-item');
      if (!container.classList.contains('expanding')) return;
      const siblings = this.closest('.product-sizes').querySelectorAll('.quick-add-size');
      siblings.forEach(el => el.classList.add('dim'));
      this.classList.remove('dim');
    });

    sizeBtn.addEventListener('mouseleave', function () {
      const container = this.closest('.product-grid-item');
      if (!container.classList.contains('expanding')) return;
      const siblings = this.closest('.product-sizes').querySelectorAll('.quick-add-size');
      siblings.forEach(el => el.classList.remove('dim'));
    });

    sizeBtn.addEventListener('click', function () {
      const variantId = this.getAttribute('data-variant-id');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(response => response.json())
      .then(data => {
        const container = this.closest('.product-grid-item');
        const sizes = container.querySelector('.product-sizes');

        container.classList.remove('expanding');
        sizes.classList.remove('expanded');
        sizes.querySelectorAll('.quick-add-size').forEach(el => {
          el.classList.remove('added', 'dim');
          el.style.opacity = '1';
        });
        this.classList.add('added');

        // ✅ Open cart drawer after adding
        if (typeof openCartDrawer === 'function') {
          openCartDrawer();
        }
      })
      .catch(error => console.error('Error adding to cart:', error));
    });
  });
}

// Run on normal page load
document.addEventListener('DOMContentLoaded', () => {
  initQuickAdd();
});

// Run after Shopify section loads (theme editor / dynamic page sections)
document.addEventListener('shopify:section:load', (e) => {
  initQuickAdd(e.target);
});